import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from "@angular/router";
import { Baseproperties } from "../views/utility/baseproperties";

@Injectable({ providedIn: 'root' })
export class Loginservices {
    isUserLoggedIn = new BehaviorSubject<boolean>(false)
    baseURL = location.origin+"/common/";
        baseproperties: Baseproperties = new Baseproperties(); 
    
    tokenKeyURL=location.origin+"/common/api/getuniquekey";
        private commonUrl=this.baseproperties.gatewayBaseURL+'/common'

    constructor(private _http: HttpClient, private route: Router) {

    }
    public doLogin(data: any): Observable<any> {
        return this._http.post(this.baseURL + "api/login", data);
    }
    
      public forgotpassword(data: any): Observable<any> {
        return this._http.post(this.baseURL + "api/forgotpassword", data);
    }
      public trainingmsg(): Observable<any> {
        return this._http.get(this.baseURL + "api/trainingmsg");
    }
    public sessiontoken(): Observable<any> {
        return this._http.get(this.baseURL + "api/session");
    }
    public verifylink(data:any): Observable<any> {
        return this._http.post(this.baseURL + "api/verifylink", data);
    }
    public getadmindetailsforcontact(data:any): Observable<any> {
        return this._http.post(this.baseURL + "api/getadmindetailsforcontact", data);
    }
    

    public resetpassword(data:any): Observable<any> {
        return this._http.post(this.baseURL + "api/resetpassword", data);
    }
       public changepassword(data:any): Observable<any> {
        return this._http.post(this.baseURL + "api/changepassword", data);
    }
     public verifyotppwd(data:any): Observable<any> {
        return this._http.post(this.baseURL + "api/verifyotppwd", data);
    }
      public sendotpforpassword(data:any): Observable<any> {
        return this._http.post(this.baseURL + "api/sendotpforpassword", data);
    }
      public verifymfaotp(data:any): Observable<any> {
        return this._http.post(this.baseURL + "api/verifymfaotp", data);
    }
  
     public logoutapi() {
       localStorage.clear();
       
            return this._http.get(`${this.commonUrl}/generic/logout/`);
      // localStorage.clear();
      // window.location.href = location.origin + "/common/#/login"
  }

    getLoggeduser(){      
        if(localStorage.getItem('userdata')!==null){
            let data =JSON.parse(localStorage.getItem('userdata'));
            if(data.token)
            {
             return JSON.parse(localStorage.getItem('userdata'));
            }  else{
                   return undefined
            }
                } else{
            return undefined
        } 
      }
  getchecktokenvalidity(): Observable <any>
  {
        return this._http.get(`${this.commonUrl}/api/checktokenvalidity`);
  }
    getUniqueKey(): Promise<string> {
        return new Promise((resolve, reject) => {
          this._http.get<any>(this.tokenKeyURL).toPromise()
            .then((res: any) => {
              if (res && res.loginkey) {
                resolve(res.loginkey);
              } else {
                reject('Error: Unique key not found');
              }
            })
            .catch((error: any) => {
              reject('Error fetching unique key');
            });
        });
      }

    public getAuthorities(): boolean {
        let acc=false;
        const userdata = this.getLoggeduser();
                if(userdata!==undefined)
     {   if (userdata.token!==undefined) {
            acc= true;
          }}
          return acc;
    }

 
    public isUserValidFor(object: string, right: string): boolean {
        let l = JSON.parse(localStorage.getItem('login'));
        if (l == undefined || l == null) {
            return false;
        }
        let v: Array<any> = l.objectAccess;
        if (v.length > 0) {
            for (let i = 0; i < v.length; i++) {
                if (v[i].objectName == object) {
                    if (right == 'view') {
                        return v[i].viewAllRights || v[i].viewRights;
                    }
                    if (right == 'create') {
                        return v[i].createRights;
                    }
                    if (right == 'edit') {
                        return v[i].editRights;
                    }
                    if (right == 'delete') {
                        return v[i].deleteRights;
                    }
                }
            }
        }
        return false;
    }


}
export class Login {
    emailid: string = '';
    paswd: string = ''
}
export class ObjectAccessResponse { }
